<template>
  <div id="footer" class="bg-dark">
    <hr />
    <h1 class="text-center text-light">{{ this.text }}</h1>
    <h2 class="text-center text-light">
      <b-link href="tel:8047483099">(804) 748-3099</b-link>
    </h2>
    <h3>
      <b-link to="contact" class="text-light text-center d-block">Click here to contact us today!</b-link>
    </h3>
    <br>
    <div style="margin: 0 auto;">
    <a
      target="_blank"
      title="Click for the Business Review of Commonwealth Moisture & Mold Specialists, LLC, a Mold & Mildew Inspection/Removal/Remediation in Chester VA"
      href="https://www.bbb.org/us/va/chester/profile/mold-removal/commonwealth-moisture-mold-specialists-llc-0603-63389622#sealclick"
    >
      <b-img
        fluid
        alt="Click for the BBB Business Review of this Mold & Mildew Inspection/Removal/Remediation in Chester VA"
        style="border: 0; display: block; margin: 0 auto;"
        src="https://seal-Richmond.bbb.org/seals/blue-seal-293-61-whitetxt-commonwealthmoisturemoldspecialistsllc-63389622.png"
      />
    </a>
    </div>
    <br>
    <p
      class="text-center text-light d-block"
    >&copy; 2020 Commonwealth Moisture and Mold Specialists, LLC</p>
    <br />
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    text: {
      default: 'FREE INSPECTIONS!',
      type: String
    }
  }
};
</script>

<style scoped>
</style>
